module.exports = {
	"1": {
		"id": 1,
		"name": "Мебель",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"2": {
		"id": 2,
		"name": "Бытовая техника",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"3": {
		"id": 3,
		"name": "Коробки",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"4": {
		"id": 4,
		"name": "Растения",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"5": {
		"id": 5,
		"name": "Тренажеры",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"6": {
		"id": 6,
		"name": "Сейф",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"7": {
		"id": 7,
		"name": "Бильярд",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"8": {
		"id": 8,
		"name": "Пианино / Рояль",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"9": {
		"id": 9,
		"name": "Игровые автоматы",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"10": {
		"id": 10,
		"name": "Хрупкие грузы",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"11": {
		"id": 11,
		"name": "Контейнер",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"12": {
		"id": 12,
		"name": "Кровать",
		"is_true_cargo": true,
		"parent_id": 1,
		"predefined": [],
		"attributes": []
	},
	"13": {
		"id": 13,
		"name": "Шкаф",
		"is_true_cargo": true,
		"parent_id": 1,
		"predefined": [],
		"attributes": []
	},
	"14": {
		"id": 14,
		"name": "Диван",
		"is_true_cargo": true,
		"parent_id": 1,
		"predefined": [],
		"attributes": []
	},
	"15": {
		"id": 15,
		"name": "Холодильник",
		"is_true_cargo": true,
		"parent_id": 2,
		"predefined": [],
		"attributes": []
	},
	"16": {
		"id": 16,
		"name": "Плита",
		"is_true_cargo": true,
		"parent_id": 2,
		"predefined": [],
		"attributes": []
	},
	"17": {
		"id": 17,
		"name": "Стиральная машина",
		"is_true_cargo": true,
		"parent_id": 2,
		"predefined": [],
		"attributes": []
	},
	"18": {
		"id": 18,
		"name": "Личные вещи",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"19": {
		"id": 19,
		"name": "Другое",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"20": {
		"id": 20,
		"name": "Сантехника",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"21": {
		"id": 21,
		"name": "Квартирный",
		"is_true_cargo": false,
		"predefined": [
			{
				"id": 30,
				"name": "Холодильник",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 60
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 60
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 180
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 648000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 80
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					},
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 60
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 60
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 180
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 648000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 80
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					}
				]
			},
			{
				"id": 3,
				"name": "Диван 3-местный",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 100
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 250
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 90
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 2250000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 50
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					}
				]
			},
			{
				"id": 39,
				"name": "Стиральная машина",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 60
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 60
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 80
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 288000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 40
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					},
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 60
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 60
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 80
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 288000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 40
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					}
				]
			},
			{
				"id": 500,
				"name": "Сумки с личными вещами",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 80
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 50
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 50
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 10
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 200000
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list"
					}
				]
			},
			{
				"id": 9,
				"name": "Кресло среднее",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 80
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 100
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 80
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 640000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 10
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					}
				]
			},
			{
				"id": 68,
				"name": "Средние коробки",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 50
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 50
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 50
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 125000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 10
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					},
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 50
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 50
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 50
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 125000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 10
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					}
				]
			},
			{
				"id": 11,
				"name": "Тумбочка",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 60
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 60
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 60
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 216000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 10
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					}
				]
			},
			{
				"id": 49,
				"name": "Телевизор",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 60
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 60
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 60
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 216000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 10
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					}
				]
			},
			{
				"id": 17,
				"name": "Стул",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 50
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 50
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 100
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 250000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 2
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					}
				]
			},
			{
				"id": 429,
				"name": "Стол",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 120
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 80
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 90
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 10
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 864000
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list"
					}
				]
			},
			{
				"id": 27,
				"name": "Шкаф",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 60
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 120
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 200
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 1440000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 20
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					}
				]
			},
			{
				"id": 29,
				"name": "Комод",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 50
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 100
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 100
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 500000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 20
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					}
				]
			},
			{
				"id": 2,
				"name": "Диван 2-местный",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 100
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 200
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 90
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 1800000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 28
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					}
				]
			},
			{
				"id": 1,
				"name": "Диван",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 100
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 200
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 90
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 1800000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 28
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					}
				]
			},
			{
				"id": 69,
				"name": "Коробки",
				"stuff_type_id": 21,
				"attributes": [
					{
						"id": 3,
						"name": "width",
						"type": "number",
						"value": 50
					},
					{
						"id": 2,
						"name": "length",
						"type": "number",
						"value": 50
					},
					{
						"id": 4,
						"name": "height",
						"type": "number",
						"value": 50
					},
					{
						"id": 5,
						"name": "volume",
						"type": "number",
						"value": 125000
					},
					{
						"id": 6,
						"name": "weight",
						"type": "number",
						"value": 8
					},
					{
						"id": 7,
						"name": "unit_of_measurement",
						"type": "list",
						"value": [
							1
						]
					}
				]
			}
		],
		"attributes": []
	},
	"22": {
		"id": 22,
		"name": "Дачный",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"23": {
		"id": 23,
		"name": "Офисный",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"24": {
		"id": 24,
		"name": "Частный дом",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"25": {
		"id": 25,
		"name": "Автомобили",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"26": {
		"id": 26,
		"name": "Мототехника",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"27": {
		"id": 27,
		"name": "Водный транспорт",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"28": {
		"id": 28,
		"name": "Запчасти",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"29": {
		"id": 29,
		"name": "Другие ТС и прицепы",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"30": {
		"id": 30,
		"name": "Перевозка автобусов",
		"is_true_cargo": false,
		"parent_id": 29,
		"predefined": [],
		"attributes": []
	},
	"31": {
		"id": 31,
		"name": "Перевозка грузовиков",
		"is_true_cargo": false,
		"parent_id": 29,
		"predefined": [],
		"attributes": []
	},
	"32": {
		"id": 32,
		"name": "Квадроцикл",
		"is_true_cargo": true,
		"parent_id": 26,
		"predefined": [],
		"attributes": []
	},
	"33": {
		"id": 33,
		"name": "Катер",
		"is_true_cargo": true,
		"parent_id": 27,
		"predefined": [],
		"attributes": []
	},
	"34": {
		"id": 34,
		"name": "Лодка",
		"is_true_cargo": true,
		"parent_id": 27,
		"predefined": [],
		"attributes": []
	},
	"35": {
		"id": 35,
		"name": "Гидроцикл",
		"is_true_cargo": true,
		"parent_id": 27,
		"predefined": [],
		"attributes": []
	},
	"36": {
		"id": 36,
		"name": "Снегоход",
		"is_true_cargo": true,
		"parent_id": 26,
		"predefined": [],
		"attributes": []
	},
	"37": {
		"id": 37,
		"name": "Стройматериалы",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"38": {
		"id": 38,
		"name": "Запаллеченный груз",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"39": {
		"id": 39,
		"name": "Лесоматериалы",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"40": {
		"id": 40,
		"name": "Биг-Бег (Big-Bag)",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"41": {
		"id": 41,
		"name": "Отделочные материалы",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"42": {
		"id": 42,
		"name": "Железобетонные изделия",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"43": {
		"id": 43,
		"name": "Оборудование",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"44": {
		"id": 44,
		"name": "Инструменты",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"45": {
		"id": 45,
		"name": "Лакокрасочные изделия",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"46": {
		"id": 46,
		"name": "Металл",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"48": {
		"id": 48,
		"name": "Груз навалом",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"49": {
		"id": 49,
		"name": "Щебень",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"50": {
		"id": 50,
		"name": "Химия",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"51": {
		"id": 51,
		"name": "РТИ",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"52": {
		"id": 52,
		"name": "ТНП",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"53": {
		"id": 53,
		"name": "Стеклянные изделия",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"54": {
		"id": 54,
		"name": "Тара и упаковка",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"55": {
		"id": 55,
		"name": "Макулатура",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"56": {
		"id": 56,
		"name": "Лом",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"57": {
		"id": 57,
		"name": "Двери",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"58": {
		"id": 58,
		"name": "Пластик",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"59": {
		"id": 59,
		"name": "Строительный мусор",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"60": {
		"id": 60,
		"name": "Бытовой мусор",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"61": {
		"id": 61,
		"name": "Опасные материалы",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"62": {
		"id": 62,
		"name": "Консервы",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"63": {
		"id": 63,
		"name": "Алкоголь",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"64": {
		"id": 64,
		"name": "Безалкогольные напитки",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"65": {
		"id": 65,
		"name": "Крупы",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"66": {
		"id": 66,
		"name": "Мороженные и охлажденные продукты",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"67": {
		"id": 67,
		"name": "Овощи",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"68": {
		"id": 68,
		"name": "Фрукты",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"69": {
		"id": 69,
		"name": "Мясные изделия",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"70": {
		"id": 70,
		"name": "Рыба",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"71": {
		"id": 71,
		"name": "Нефтепродукты",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"72": {
		"id": 72,
		"name": "Хим. продукты (неопасные)",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"73": {
		"id": 73,
		"name": "Хим. продукты (опасные)",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"74": {
		"id": 74,
		"name": "Песок",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"75": {
		"id": 75,
		"name": "Торф",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"76": {
		"id": 76,
		"name": "Уголь",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"77": {
		"id": 77,
		"name": "Зерно и семена (в упаковке)",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"78": {
		"id": 78,
		"name": "Зерно и семена (насыпью)",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"81": {
		"id": 81,
		"name": "Кормовые / пищевые добавки",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"82": {
		"id": 82,
		"name": "Молоко сухое",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"83": {
		"id": 83,
		"name": "Животные",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"84": {
		"id": 84,
		"name": "Перевозка по городу",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"85": {
		"id": 85,
		"name": "Междугородняя перевозка",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"86": {
		"id": 86,
		"name": "Каблук (до 650 кг.)",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"87": {
		"id": 87,
		"name": "Портер, Соболь (до 1т.)",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"88": {
		"id": 88,
		"name": "Газель (аналоги, до 1,5 т.)",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"89": {
		"id": 89,
		"name": "Бычок (аналоги, до 3 т.)",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"90": {
		"id": 90,
		"name": "5-ти тонник",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"91": {
		"id": 91,
		"name": "10-ти тонник",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"92": {
		"id": 92,
		"name": "20-ти тонник",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"93": {
		"id": 93,
		"name": "Спец. транспорт",
		"is_true_cargo": true,
		"predefined": [],
		"attributes": []
	},
	"94": {
		"id": 94,
		"name": "Домашние животные",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	},
	"95": {
		"id": 95,
		"name": "Сельскохозяйственные животные",
		"is_true_cargo": false,
		"predefined": [],
		"attributes": []
	}
};


//////////////////
// WEBPACK FOOTER
// ./configs/cargos.config.json
// module id = 1592
// module chunks = 0